import './resizeObserverPatch';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style/opus-tokens.css';
import App from './App';
import client from './apolloClient';
import { ApolloProvider } from '@apollo/client';
import ErrorBoundary from './components/resilience/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Root boundary: a render-time throw anywhere below used to unmount the whole
  // tree and leave a white screen.
  <ErrorBoundary variant="root">
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </ErrorBoundary>
);
